// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAzPETcbxgY2Nz1rBrmP9XG29M_YEbr86E",
  authDomain: "vilanoconsulting.firebaseapp.com",
  projectId: "vilanoconsulting",
  storageBucket: "vilanoconsulting.firebasestorage.app",
  messagingSenderId: "442927719105",
  appId: "1:442927719105:web:3a5a1f506fd1720c806a40",
  measurementId: "G-50DRDFJEQQ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (optional)
getAnalytics(app);

// Export Firestore
export const db = getFirestore(app);
